export default __webpack_public_path__ + "2ba5d05f7a07a10b9bfd7174d2056639.png";